import { ArrowForward, CloseRounded } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Radio,
  SwipeableDrawer,
  Tooltip,
} from '@mui/material';

import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { stringAvatar } from '../../utils/avatarGenerator';

import { Guest, getMeetingByIdRequest } from '../../services';
import { MinutesProps } from '../../services/requests/ata/types';
import { DocuSign } from '../../services/requests/docuSign/type';
import { postDocumentToDocuSign } from '../../services/requests/docuSign/utils';
import useAuthStore from '../../store/auth';
import { DrawerConfigureSignature } from '../DrawerConfigureSignature';

import { DrawerConfirmRequestSignatures } from '../DrawerConfirmRequestSignatures';
import { DrawerSuccessMensage } from '../DrawerSuccessMensage';
import {
  CardIcp,
  CardSign,
  CardUsers,
  Container,
  Header,
  Text,
} from './styles';
import { sendMinuteForD4signRequest } from '../../services/requests/d4sign/utils';
import { D4signMinute } from '../../services/requests/d4sign/types';
import useMeetingStore from '../../store/meetings';
import SignIcon from '../../assets/IconSignature.svg';
import IcpIcon from '../../assets/IconCertificate.svg';

interface DrawerRequestSignaturesProps {
  setOpenDrawer: (open: boolean) => void;
  listagemConvidados: Guest[];
  setMinute: (a: MinutesProps) => void;
  minute: MinutesProps;
  minuteConverted: string;
  setLoadingMinuteState: (type: boolean) => void;
  setUrlToSign: (type: string) => void;
}

interface GuestToSelect extends Guest {
  selectedUser: boolean;
}

export const DrawerRequestSignatures = ({
  setOpenDrawer,
  listagemConvidados,
  setMinute,
  minute,
  minuteConverted,
  setLoadingMinuteState,
  setUrlToSign,
}: DrawerRequestSignaturesProps) => {
  const user = useAuthStore(state => state.user);
  const setMeetingSelect = useMeetingStore(state => state.setSelectedMeetings);

  const [formattedUsers, setFormattedUsers] = useState<GuestToSelect[]>([]);
  const [listUsersSignatures, setListUsersSignatures] = useState<Guest[]>([]);
  const [openDrawerConfigureSignature, setOpenDrawerConfigureSignature] =
    useState(false);
  // const [urlDocuSign, setUrlDocuSign] = useState('');
  const [stepDrawer, setStepDrawer] = useState('signType');
  const [loadingMinute, setLoadingMinute] = useState(false);
  const [loadingConfigureMinuteState, setLoadingConfigureMinuteState] =
    useState(false);
  const [
    stateControlMinuteConfigureSignature,
    setStateControlMinuteConfigureSignature,
  ] = useState(false);
  const [finalMinute, setFinalMinute] = useState<any>();
  const [hasIcpSign, setHasIcpSign] = useState<boolean>(false);

  const timerRefConfigure = useRef<any>(null);
  const params = useParams();

  const getMeetingById = useCallback(async () => {
    try {
      const response = await getMeetingByIdRequest(
        params?.id as string,
        user?.id as string,
      );

      setMeetingSelect(response);
      setUrlToSign(
        `https://secure.d4sign.com.br/embed/viewblob/${response?.envelope_id}?email=${user?.email}`,
      );
    } catch (err) {
      console.log(err);
    }
  }, [params?.id, setMeetingSelect, setUrlToSign, user?.email, user?.id]);

  const handleCloseDrawerSuccessMensage = () => {
    const signers = listUsersSignatures?.map(u => ({
      id: u.id,
      name: u.name,
      email: u.email,
      profile: u.profile,
    }));

    setOpenDrawer(false);
    setStepDrawer('signType');

    setMinute({
      ...minute,
      status: 'CS2',
      signatures: signers,
    });

    setLoadingMinuteState(true);

    setTimeout(() => {
      getMeetingById();
      setLoadingMinuteState(false);
    }, 5000);
  };

  const handleUserToInvite = useCallback(
    (
      event: React.MouseEvent<unknown>,
      name: string,
      usr: GuestToSelect,
      idx: number,
      type: 'select',
    ) => {
      let listaUsuarios = { ...usr };

      if (type === 'select') {
        listaUsuarios.selectedUser = !usr?.selectedUser;
      }

      formattedUsers?.splice(idx, 1, listaUsuarios);

      setFormattedUsers([...formattedUsers!]);
      const usuariosConvidados = formattedUsers?.filter(u => u.selectedUser);
      setListUsersSignatures([...usuariosConvidados!]);
    },
    [formattedUsers, setFormattedUsers, setListUsersSignatures],
  );

  useEffect(() => {
    if (listagemConvidados.length > 0) {
      const guests = listagemConvidados.map((u: Guest) => ({
        ...u,
        profile: 'GS2',
        selectedUser: false,
      }));

      setFormattedUsers(guests as any);
    }
  }, [setFormattedUsers, listagemConvidados]);

  const handleConfigureAta = useCallback(async () => {
    try {
      setLoadingMinute(true);
      const signers = listUsersSignatures?.map(u => ({
        id: u.id,
        name: u.name,
        email: u.email,
        profile: u.profile,
      }));

      const meetingId = params?.id as string;

      const minuteFinal: DocuSign = {
        pdfBase64: minuteConverted,
        returnUrl: `https://sandbox.d4sign.com.br/embed/viewblob/${minute?.fileId}?email=${user?.email}`,
        // returnUrl: `${process.env.REACT_APP_API_URL}/assinaturas-sucesso/${meetingId}`,
        ownerId: user?.id as string,
        fileId: minute?.fileId as string,
        fileName: minute?.name as string,
        signers,
        meetingId,
      };

      setFinalMinute(minuteFinal);

      const createMinuteForD4Sign: D4signMinute = {
        meetingId,
        pdfBase64: minuteConverted,
        fileName: minute?.name,
        ownerId: user?.id as string,
        signers,
        fileId: minute?.fileId,
        mimeType: 'application/pdf',
        isIcp: hasIcpSign,
      };

      const response = await sendMinuteForD4signRequest(createMinuteForD4Sign);

      console.log({ response });

      if (response?.status === 201) {
        // setUrlDocuSign(response?.data.url);
        handleCloseDrawerSuccessMensage();
        toast.success('Assinatura solicitada com sucesso! ');

        // setOpenDrawerConfigureSignature(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingMinute(false);
    }
  }, [
    listUsersSignatures,
    params?.id,
    minuteConverted,
    minute?.fileId,
    minute?.name,
    user?.email,
    user?.id,
    hasIcpSign,
    handleCloseDrawerSuccessMensage,
  ]);

  // async function handleConfigureSignatures() {
  //   const subs = finalMinute?.signers.map((u: any) => ({
  //     ...u,
  //     profile: 'SS2',
  //   }));

  //   const data = {
  //     ...finalMinute,
  //     signers: subs,
  //   };

  //   const response = await postDocumentToDocuSign(data);

  //   if (response?.data.url.includes('Member')) {
  //     setMinute({
  //       ...minute,
  //       status: 'CS2',
  //     });
  //     clearInterval(timerRefConfigure.current);
  //     setLoadingMinuteState(false);
  //   }
  // }

  // const drawerConfigureSignature = () => (
  //   <Box width="95vw" height="100%">
  //     <DrawerConfigureSignature
  //       setOpenDrawerConfigureSignature={setOpenDrawerConfigureSignature}
  //       urlDocuSign={urlDocuSign}
  //       // eslint-disable-next-line react/jsx-no-bind
  //       handleConfigureSignatures={handleConfigureSignatures}
  //       timerRefConfigure={timerRefConfigure}
  //       setLoadingConfigureMinuteState={setLoadingConfigureMinuteState}
  //       setStateControlMinuteConfigureSignature={
  //         setStateControlMinuteConfigureSignature
  //       }
  //       setLoadingMinuteState={setLoadingMinuteState}
  //     />
  //   </Box>
  // );

  const handleIcpDrawer = () => {
    setStepDrawer('request');
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setStepDrawer('signType');
  };

  return (
    <Box>
      {stepDrawer === 'signType' && (
        <Box width="480px" padding="20px">
          <Header>
            <CloseRounded
              sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
              onClick={handleCloseDrawer}
            />
            <span className="title">Assinatura</span>
          </Header>
          {loadingMinute ? (
            <Box display="flex" justifyContent="center" width="100%" mt="50px">
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Container marginTop="20px" overflow="auto">
                <CardSign>
                  <Radio
                    checked={hasIcpSign === false}
                    onChange={() => setHasIcpSign(prevState => !prevState)}
                    value={hasIcpSign}
                    name="radio-buttons"
                  />
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="flex-start"
                  >
                    <img src={SignIcon} alt="Logo assinatura" />
                    <span className="textSign"> Assinatura Eletrônica </span>
                  </Box>
                </CardSign>
                <CardIcp>
                  <Radio
                    checked={hasIcpSign === true}
                    onChange={() => setHasIcpSign(prevState => !prevState)}
                    value={hasIcpSign}
                    name="radio-buttons"
                  />
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    flex="1 0 0"
                  >
                    <img src={IcpIcon} alt="Logo certificado" />
                    <span className="textSign"> Assinatura Digital </span>
                    <span className="textIcp">
                      Importante: os assinantes precisam ter o certificado
                      digital e-CPF (tipo A1 ou A3) da ICP-Brasil
                    </span>
                  </Box>
                </CardIcp>
              </Container>
            </>
          )}

          <Fragment key="right">
            <Button
              variant="contained"
              color="success"
              onClick={handleIcpDrawer}
              sx={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                color: '#FFFFFF',
                fontSize: '15px',
                padding: '6px 16px 6px 22px',
                display: 'flex',
                gap: '10px',
                fontWeight: '600',
              }}
            >
              Prosseguir <ArrowForward />
            </Button>

            {/* <SwipeableDrawer
              onClose={() => setOpenDrawerConfigureSignature(true)}
              onOpen={() => setOpenDrawerConfigureSignature(true)}
              open={openDrawerConfigureSignature}
              anchor="right"
            >
              {drawerConfigureSignature()}
            </SwipeableDrawer> */}
          </Fragment>
        </Box>
      )}
      {stepDrawer === 'request' && (
        <Box width="480px" padding="20px">
          <Header>
            <CloseRounded
              sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
              onClick={handleCloseDrawer}
            />
            <span className="title">Assinatura</span>
          </Header>
          {loadingMinute ? (
            <Box display="flex" justifyContent="center" width="100%" mt="50px">
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Container marginTop="20px" overflow="auto">
                <Text>Selecione quem irá assinar o documento</Text>
                {formattedUsers?.map((u, index) => (
                  <Tooltip title={u.email}>
                    <CardUsers
                      onClick={event =>
                        handleUserToInvite(event, u.name, u, index, 'select')
                      }
                    >
                      <Checkbox
                        color="primary"
                        checked={u.selectedUser === true}
                        sx={{ padding: '0' }}
                      />
                      <Box display="flex" flexDirection="row" gap="10px">
                        {u?.avatar_url ? (
                          <Avatar sx={{ width: '40px' }}>
                            <img
                              src={u?.avatar_url as string}
                              alt="Foto de perfil"
                              style={{ width: '100%' }}
                            />
                          </Avatar>
                        ) : (
                          <Avatar
                            {...stringAvatar(u.name!)}
                            sx={{ width: '40px' }}
                          />
                        )}
                        <span className="name">{u.name}</span>
                      </Box>
                    </CardUsers>
                  </Tooltip>
                ))}
              </Container>
            </>
          )}

          <Fragment key="right">
            <Button
              variant="contained"
              color="success"
              disabled={
                (listUsersSignatures && listUsersSignatures?.length === 0) ||
                loadingMinute
              }
              onClick={handleConfigureAta}
              sx={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                color: '#FFFFFF',
                fontSize: '15px',
                padding: '6px 16px 6px 22px',
                display: 'flex',
                gap: '10px',
                fontWeight: '600',
              }}
            >
              Prosseguir <ArrowForward />
            </Button>

            {/* <SwipeableDrawer
              onClose={() => setOpenDrawerConfigureSignature(true)}
              onOpen={() => setOpenDrawerConfigureSignature(true)}
              open={openDrawerConfigureSignature}
              anchor="right"
            >
              {drawerConfigureSignature()}
            </SwipeableDrawer> */}
          </Fragment>
        </Box>
      )}
      {stepDrawer === 'confirm' && (
        <DrawerConfirmRequestSignatures
          setOpenDrawerConfirmConfigureSignature={setOpenDrawer}
          users={listUsersSignatures}
          setStepDrawer={setStepDrawer}
        />
      )}
      {stepDrawer === 'success' && (
        <DrawerSuccessMensage
          setOpenDrawerSuccessMensage={setOpenDrawer}
          handleClose={handleCloseDrawerSuccessMensage}
        />
      )}
    </Box>
  );
};
